export class Helpers {

    public static getLocalStorage(name: string): string {
        return localStorage.getItem(name) || '';
    }    

    public static setLocalStorage(name: string, value: string) {
        localStorage.setItem(name, value);
    }

    public static removeLocalStorage(name: string): void {
        localStorage.removeItem(name);
    }

    public static getSessionStorage(name: string): string {
        return sessionStorage.getItem(name) || '';
    }

    public static setSessionStorage(name: string, value: string) {
        sessionStorage.setItem(name, value);
    }  

    public static removeSessionStorage(name: string): void {
        sessionStorage.removeItem(name);
    }

    /**
     * Returns token expiration in milliseconds.
     */
    public static getExp(): number {
        return parseInt(sessionStorage.getItem("exp") || '0');
    }

    public static setExp(exp: number) {
        sessionStorage.setItem("exp", exp.toString());
    }

    public static removeExp(): void {
        sessionStorage.removeItem("exp");
    }
}